var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFeedback = function SvgFeedback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16671 2.20833V16.7917H18.8334V2.20833H2.16671ZM1.12504 0.125H19.875C20.1513 0.125 20.4163 0.234747 20.6116 0.430097C20.807 0.625447 20.9167 0.890399 20.9167 1.16667V17.8333C20.9167 18.1096 20.807 18.3746 20.6116 18.5699C20.4163 18.7653 20.1513 18.875 19.875 18.875H1.12504C0.848774 18.875 0.583821 18.7653 0.388471 18.5699C0.193121 18.3746 0.083374 18.1096 0.083374 17.8333V1.16667C0.083374 0.890399 0.193121 0.625447 0.388471 0.430097C0.583821 0.234747 0.848774 0.125 1.12504 0.125ZM4.25004 4.29167H6.33337V6.375H4.25004V4.29167ZM4.25004 8.45833H6.33337V10.5417H4.25004V8.45833ZM4.25004 12.625H16.75V14.7083H4.25004V12.625ZM9.45837 8.45833H11.5417V10.5417H9.45837V8.45833ZM9.45837 4.29167H11.5417V6.375H9.45837V4.29167ZM14.6667 4.29167H16.75V6.375H14.6667V4.29167ZM14.6667 8.45833H16.75V10.5417H14.6667V8.45833Z",
    fill: "#607D8B",
    fillOpacity: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback.a1fb08e0.svg";
export { ForwardRef as ReactComponent };